// Third-party imports
import $ from 'jquery';

import { quantityHandler, resetQuantityCounter } from './quantity_handler.js';

export function getCartProducts(variantsArray, productsInCartArray) {
    let url = '/cart.js';

    // Using getJSON will ensure that the data arg passed to the handler is a js
    // object
    $.getJSON(url)
        .then(data => {
            let currentlySelectedVariantID = $('.js-variantID-hook').val();
            if (
                checkIfAVariantIsCurrentlySelected(currentlySelectedVariantID)
            ) {
                getCurrentlySelectedVariantQuantity(
                    currentlySelectedVariantID,
                    data.items,
                    variantsArray
                );
            }
            pushItemsInProductInCartArray(data.items, productsInCartArray);
            for (let index = 0; index < productsInCartArray.length; index++) {
                if (productsInCartArray[index].variant_id) {
                    if (
                        productsInCartArray[index].variant_id ===
                        variantsArray[0].variantid
                    ) {
                        resetQuantityCounter(
                            productsInCartArray[index].quantity
                        );
                    }
                }
            }
        })
        .catch(data => {
            let err = {
                msg: `GET failed for url: ${url}`,
                data,
            };
            throw err;
        });
}

function pushItemsInProductInCartArray(items, productsInCartArray) {
    items.forEach(item => {
        productsInCartArray.push(item);
    });
}

function checkIfAVariantIsCurrentlySelected(currentlySelectedVariantID) {
    return currentlySelectedVariantID ? true : false;
}

export function getCurrentlySelectedVariantQuantity(
    currentlySelectedVariantID,
    itemsInCart,
    variantsArray
) {
    if (!itemsInCart) {
        return;
    }
    itemsInCart.forEach(function(item) {
        currentlySelectedVariantID = parseInt(currentlySelectedVariantID);
        // We used to adjust the available quantity based on the quantity
        // in the cart, IF the item.id === currentlySelectedVariantID
        // But with the addition of the add to cart popup, we now overwrite
        // any quantity of product in the cart. So we have to always allow
        // the user to be able to add all quantity of the product
        if (item.id !== currentlySelectedVariantID) {
            let userSelectedVariant = getProductFromVariantsArray(
                currentlySelectedVariantID,
                variantsArray
            );
            quantityHandler(userSelectedVariant);
        }
    });
}

function getProductFromVariantsArray(
    currentlySelectedVariantID,
    variantsArray
) {
    let currentVariant;
    variantsArray.forEach(variant => {
        if (variant.variantid === currentlySelectedVariantID) {
            currentVariant = variant;
        }
    });
    return currentVariant;
}
